import { render, staticRenderFns } from "./saas-nav.vue?vue&type=template&id=778c9065&scoped=true"
import script from "./saas-nav.vue?vue&type=script&lang=js"
export * from "./saas-nav.vue?vue&type=script&lang=js"
import style0 from "./saas-nav.vue?vue&type=style&index=0&id=778c9065&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c9065",
  null
  
)

export default component.exports